


































import {
  useFetch,
  defineComponent,
  ref,
  onMounted,
} from '@nuxtjs/composition-api';
import { useStoryblokBridge } from '@storyblok/nuxt-2';
import Breadcrumbs from '~/modules/storyblok/components/Blog/BlogBreadcrumbs.vue';
import { useUser } from '~/modules/customer/composables/useUser';
import { CacheTagPrefix, useCache } from '@vue-storefront/cache';
import { useStoryblokView } from '~/modules/storyblok/composables/useStoryblokView';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';

export default defineComponent({
  name: 'BlogIndex',
  components: {
    SkeletonLoader,
    Breadcrumbs,
  },
  layout: 'basic',
  setup() {
    const { getStoryBySlug } = useStoryblokView();
    const currentStory = ref(null);
    const { isAuthenticated } = useUser();
    const { addTags } = useCache();

    const { fetch } = useFetch(async () => {
      const { story: sbStory } = await getStoryBySlug({
        slug: 'blog/',
        redirectOnError: true,
      });
      currentStory.value = sbStory;

      if (!isAuthenticated.value) {
        addTags([{ prefix: CacheTagPrefix.View, value: currentStory.value.full_slug }]);
      }
    });
    fetch();

    onMounted(() => {
      if (currentStory.value && currentStory.value.id) {
        useStoryblokBridge(currentStory.value.id, (evStory) => { (currentStory.value = evStory); }, { preventClicks: true });
      }
    });

    return {
      currentStory,
    };
  },
  head: {},
});
